/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
import React, { useState, useEffect, useCallback } from "react";
import { api } from "../../services/api";
import Tabela from "../../components/TableV";
import Menu from "../../components/Menu";
import ButtonsFilterTables from "../../components/ButtonsFilterTables";
import { MdSearch } from "react-icons/md";
import useToast from "../../hooks/useToast";
import {
  PageContent,
  PageHeader,
  PageTitle,
  PageSubtitle,
  SearchBar,
  SearchInput,
  CardList,
} from "./styled";

export default function Viagens() {
  const [viagens, setViagens] = useState([]);
  const [lineName, setLineName] = useState("");
  const [searchLine, setSearchLine] = useState("");
  const [selectedDate, setSelectedDate] = useState([]); //Pego apenas o resultado do botao do filtro que o usuario clicou

  const { showToast } = useToast();

  const bli = localStorage.getItem("LinhaID");
  const ccid = localStorage.getItem("CoastCenterID");

  localStorage.removeItem("BuslineShiftID");

  const tabela = async () => {
    try {
      const response = await api.get(
        `/busline/shift?cost_center_id=${ccid}&bus_line_id=${bli}&seg=true`
      );

      if (response.data[0]) {
        setLineName(response.data[0].name || "");
        setViagens(response.data[0].bus_line_shift);
      }
    } catch (error) {
      showToast("Nenhuma viagem encontrada ou linha nao selecionada.", "error");
      console.log(error);
    }
  };

  viagens.sort((a, b) => {
    if (a.tag.toLowerCase() < b.tag.toLowerCase()) {
      return -1;
    }
    if (a.tag.toLowerCase() > b.tag.toLowerCase()) {
      return 1;
    }
    return 0;
  });

  useEffect(() => {
    tabela();
  }, []);

  const childToParent = useCallback((childdata) => {
    setSelectedDate(childdata);
  }, []);

  let filterViagensBusca;
  const checkContains = (days) => {
    return selectedDate
      .filter((item) => item !== "ida" && item !== "retorno")
      .every((e) => days.includes(e));
  };

  filterViagensBusca = viagens.filter((r) => {
    for (let i = 0; i < r.weekday.length; i++) {
      if (
        (r.tag.includes(searchLine) ||
          r.direction.direction_name
            .toUpperCase()
            .includes(searchLine.toUpperCase()) ||
          r.hour.includes(searchLine) ||
          r.hour_end.includes(searchLine) ||
          r.weekday[i].toUpperCase().includes(searchLine.toUpperCase())) &&
        checkContains(r.weekday) &&
        (selectedDate.includes(r.direction.direction_name.toLowerCase()) ||
          (!selectedDate.includes("ida") && !selectedDate.includes("retorno")))
      ) {
        return true;
      }
    }
    return false;
  });

  return (
    <>
      <Menu title="Viagens" />
      <PageContent>
        <PageHeader>
          <PageTitle>{lineName || "Viagens"}</PageTitle>
          <PageSubtitle>Viagens disponiveis para esta linha</PageSubtitle>
        </PageHeader>

        <SearchBar>
          <MdSearch
            size={20}
            style={{
              position: "absolute",
              left: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              color: "#adb5bd",
            }}
          />
          <SearchInput
            name="pesquisa_search-line"
            type="text"
            placeholder="Buscar por viagem"
            value={searchLine}
            onChange={(env) => setSearchLine(env.target.value)}
          />
        </SearchBar>

        <ButtonsFilterTables childToParent={childToParent} />

        <CardList>
          {filterViagensBusca.map((data, index) => (
            <Tabela key={index} data={data} />
          ))}
        </CardList>
      </PageContent>
    </>
  );
}
